import LogoGrande from '../LogoGrande/LogoGrande';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';

const BannerLogo = () => {
  return (
    <div className="relative h-[120px] sm:h-[140px] md:h-[160px] lg:h-[180px] w-full mx-auto">
      {/* Contenedor centrado para el LogoGrande */}
      <div className="absolute inset-0 flex justify-center items-center py-3">
        <LogoGrande />
      </div>
      {/* Selector de idioma — esquina superior derecha */}
      <div className="absolute top-2 right-3 md:top-3 md:right-5">
        <LanguageSwitcher />
      </div>
    </div>
  );
};

export default BannerLogo;
